/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgentGroup } from '../../models/agent-group';
import { ApiResponseAgentGroup } from '../../models/api-response-agent-group';

export interface CreateAgentGroup$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: AgentGroup
}

export function createAgentGroup(http: HttpClient, rootUrl: string, params: CreateAgentGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAgentGroup>> {
  const rb = new RequestBuilder(rootUrl, createAgentGroup.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseAgentGroup>;
    })
  );
}

createAgentGroup.PATH = '/v1/api/ui/agent-group';
